import { STORAGE_PREFIX } from '@root/shared'

import type { TelegramAuthAction } from './telegram-auth-action'
import type { TelegramAuthToken } from '@root/entities/auth'
import type { InviteCode } from '@root/entities/referral/model/referral-code'

export interface TelegramLocalAuthData {
  token: TelegramAuthToken
  action: TelegramAuthAction | undefined
  referralCode: InviteCode | undefined
}

export const TELEGRAM_TOKEN_KEY = `${STORAGE_PREFIX}/v1/tg-auth`

export const get = () =>
  JSON.parse(
    localStorage.getItem(TELEGRAM_TOKEN_KEY) || 'null',
  ) as TelegramLocalAuthData | null

export const set = (data: TelegramLocalAuthData) =>
  localStorage.setItem(TELEGRAM_TOKEN_KEY, JSON.stringify(data))

export const remove = () => localStorage.removeItem(TELEGRAM_TOKEN_KEY)
